/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { WalletStatus } from '../types/utils';

export type WalletID = string;

export class Wallet {
	publicKey: string = ''

	encryptedPrivateKey: string = ''

	status: WalletStatus = WalletStatus.ACTIVE
}